import { jsx as _jsx } from "react/jsx-runtime";
import UIComponent from './uiComponent';
import { resovleContent } from './utils';
import { ulid } from 'ulidx';
import UITheme from './uiTheme';
export default class UIContainer extends UIComponent {
    width;
    constructor(s) {
        super(s);
        this.width = this.getProperty('width', '100%');
        resovleContent(this, s);
    }
    getComponent() {
        const children = [];
        for (const c of this.children) {
            const component = c.getComponent();
            children.push(component);
        }
        return (_jsx(UITheme, { children: _jsx("div", { style: { width: this.width }, children: children }, ulid()) }));
    }
}
//# sourceMappingURL=uiContainer.js.map